/**
 * WordPress dependencies
 */
import { BaseControl } from '@wordpress/components';
import { withInstanceId } from '@wordpress/compose';
import { __ } from '@wordpress/i18n';

/**
 * External dependencies
 */
import Select from 'react-select';

// googleFonts
import defaultFonts from './fonts';

const faqmateThemeFonts = faqmateParams?.theme_fonts;

const faqmateAvailableFonts = [];

if (faqmateThemeFonts) {
    faqmateThemeFonts.map(font => {
        faqmateAvailableFonts.push({ value: font, label: font });
    });
}

const FontPicker = ({ value, onChange, instanceId }) => {
    const fonts = [
        { value: 'inherit', label: __('Default', 'faqmate-blocks') },
        { value: 'Arial', label: 'Arial' },
        { value: 'Helvetica', label: 'Helvetica' },
        { value: 'Times-New-Roman', label: 'Times New Roman' },
        { value: 'Georgia', label: 'Georgia' }
    ];

    // push google fonts
    Object.keys(defaultFonts).map(font => fonts.push({ value: font, label: defaultFonts[font].family }));

    // push theme fonts
    if (faqmateAvailableFonts && faqmateAvailableFonts.length > 0) {
        faqmateAvailableFonts.map(font => fonts.push(font));
    }

    const onFontChange = select => {
        const selectedFont = select.label;

        if (selectedFont) {
            if (
                selectedFont === 'Default' ||
                selectedFont === 'Arial' ||
                selectedFont === 'Helvetica' ||
                selectedFont === 'Times-New-Roman' ||
                selectedFont === 'Georgia' ||
                fonts.find(font => font.value === selectedFont)
            ) {
                onChange(selectedFont);
                return;
            }
        }

        const googleFontsAttr = ':100,200,300,400,500,600,700,800,900';
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        if (selectedFont) {
            link.href = 'https://fonts.googleapis.com/css?family=' + selectedFont.replace(/ /g, '+') + googleFontsAttr;
            document.head.appendChild(link);
        }
        onChange(selectedFont);
    };

    return (
        <div className="faqmate-font-picker">
            <BaseControl id={`faqmate-font-picker-${instanceId}`} label={__('Family', 'faqmate-blocks')}>
                <Select
                    classNamePrefix="faqmate"
                    value={{
                        value: (value || '').replace(/\s+/g, '-'),
                        label: value
                    }}
                    onChange={onFontChange}
                    options={fonts}
                    unstyled={true}
                    isSearchable={true}
                    isClearable={false}
                    placeholder={__('Select font', 'faqmate-blocks')}
                    isLoading={faqmateAvailableFonts && faqmateAvailableFonts.length > 0 ? false : true}
                />
            </BaseControl>
        </div>
    );
};
export default withInstanceId(FontPicker);
